import type { MergedAchievement } from './hooks/useMyAchievements';
import type { Category } from './components/AchievementTabs';

// WHY: filter by `uiTab`, not `category`: category is the rule bucket (start|risk|loyalty…) and empties 6/8 tabs
export function filterByTab(items: MergedAchievement[], cat: Category): MergedAchievement[] {
  if (cat === 'all') return items;
  return items.filter((m) => m.uiTab === cat);
}
